import { UserRole } from '../types/users';

export const PRICE_SURVEY_DATA_UPLOAD_ROLES: UserRole[] = [
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.PROCUREMENT_MANAGER,
    UserRole.DIVISIONAL_MANAGER,
];
